import { Injectable } from "@angular/core";
import { CanActivate, CanLoad, CanDeactivate, Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable, from, of } from "rxjs";
import * as AuthenticationActions from '../../screens/login/state/login.actions';
import * as fromAuthentication from '../../screens/login/state/login.selectors';
import { catchError, map, take } from 'rxjs/operators';
import { AuthenticationService } from "..";

export interface DeactivationLoginGuard {
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class LoginGuard implements CanActivate, CanLoad, CanDeactivate<DeactivationLoginGuard> {
    constructor(private store: Store<fromAuthentication.State>, private auth: AuthenticationService, private router: Router) { }

    private authenticateSession(): Observable<any> {
        return this.authenticateSessionPromise().pipe(
            map((data: any) => data)
        );
    }

    private authenticateSessionPromise(): Observable<any> {
        return this.auth.validateSession().pipe(

            map(result => of('good')),
            catchError(err => of('bad'))
        )
    }
    canActivate(): Observable<boolean> | boolean {
        return this.authenticateSession().pipe(
            map((authed: any) => {
                if (authed === 'bad')
                    return false;
                this.store.dispatch(new AuthenticationActions.Logout());
                return true;
            })
            , take(1)
            , catchError((error: any) => of(false))
        );
    }
    canLoad(): Observable<boolean> {
        return this.authenticateSession().pipe(
            map(authed => {
                if (authed === 'bad')
                    return true;
                return false;
            })
            , take(1)
        );
    }
    canDeactivate(): Observable<boolean> | boolean {
        return this.authenticateSession().pipe(
            map(authed => {
                if (authed === 'bad')
                    return true;
                return false;
            })
        )
    }
}